import { render, staticRenderFns } from "./VisitDetail.vue?vue&type=template&id=410a4599&scoped=true"
import script from "./VisitDetail.vue?vue&type=script&lang=js"
export * from "./VisitDetail.vue?vue&type=script&lang=js"
import style0 from "./VisitDetail.vue?vue&type=style&index=0&id=410a4599&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410a4599",
  null
  
)

export default component.exports